import { render, staticRenderFns } from "./ReqDocu.vue?vue&type=template&id=61e0acdc&scoped=true"
import script from "./ReqDocu.vue?vue&type=script&lang=js"
export * from "./ReqDocu.vue?vue&type=script&lang=js"
import style0 from "./ReqDocu.vue?vue&type=style&index=0&id=61e0acdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0acdc",
  null
  
)

export default component.exports